import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';

class SingleDataContainer extends React.Component {
    componentDidMount() {
        const {
            data,
        } = this.props;

        if (utils.isEmpty(data)) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.fetchData();
        }
    }

    fetchData() {
        const {
            action,
            dispatchAction,
            id,
        } = this.props;

        if (utils.isEmpty(id)) {
            return;
        }

        /**
         * This will trigger a specific action, which is defined in the upper level.
         * This action can only be a function, and will always pass the id of the record.
         */
        dispatchAction(action({
            id: id,
        }));
    }

    render() {
        const {
            data,
        } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        return this.props.children({
            data: data,
        });
    }
}

SingleDataContainer.propTypes = {
    action: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
    data: PropTypes.object,
    dispatchAction: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

const mapStateToProps = (state, props) => {
    const { id, resource } = props;

    const stateResource = state[resource];

    return {
        data: stateResource.data[id],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (action) => {
            dispatch(action);
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SingleDataContainer);



// WEBPACK FOOTER //
// ./src/containers/Data/SingleDataContainer.js